module.exports = __webpack_public_path__ + "assets/img/13.4fdb71ff.png";